function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PropertyTitle from './RecordComparePropertyTitle';
import React, { useCallback, useContext, useMemo } from 'react';
import styles from './RecordCompareArrayRow.module.scss';
import useRecordLabel from '../../hooks/useRecordCompareLabel';
import { Column, Row } from '../Layout/RecordCompareLayout';
import get from '../../../utils/get';
import { getColumnId } from '../../util/recordCompareAria';
import { arrayHasAllEnabledFields } from '../../util/recordCompareSelect';
import CompareContext from './RecordCompareContext';
import RecordCompareStateContext from '../../RecordCompareStateContext';
import CheckboxInput from '../../../Inputs/CheckboxInput/CheckboxInput';
import I18n from '../../../I18n/I18n/I18n';
import Tooltip from '../../../Tips/Tooltip/Tooltip';
import LazyContainer from '../../../LazyContainer/LazyContainer';
import ThemeContext from '../../../ThemeContext';
var getItemName = get('ui:options.itemName');
function ItemName(_ref) {
  var uiSchema = _ref.uiSchema,
    property = _ref.property,
    rowNumber = _ref.rowNumber;
  var itemName = getItemName(uiSchema[property]);
  var i18n = useMemo(function () {
    if (itemName && itemName.trim().length) {
      return {
        id: '@dm/components.record-compare.labels.itemName',
        values: {
          itemName: itemName,
          rowNumber: rowNumber
        }
      };
    }
    return {
      id: '@dm/components.record-compare.labels.item',
      values: {
        rowNumber: rowNumber
      }
    };
  }, [itemName, rowNumber]);
  return /*#__PURE__*/React.createElement(I18n, {
    i18n: i18n
  });
}
function FieldTitle(_ref2) {
  var property = _ref2.property;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.field
  }, /*#__PURE__*/React.createElement(PropertyTitle, {
    property: property
  }));
}
function FieldValue(props, theme) {
  var arrayProperty = props.arrayProperty,
    property = props.property,
    rowNumber = props.rowNumber,
    record = props.record,
    index = props.index;
  var _useRecordLabel = useRecordLabel(index, property, true),
    label = _useRecordLabel.label,
    isEmpty = _useRecordLabel.isEmpty,
    escape = _useRecordLabel.escape;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.field, " ").concat(isEmpty ? "".concat(styles[theme], " ").concat(styles.field, " ").concat(styles.empty) : '')
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "array-select-".concat(arrayProperty, "-").concat(record.recordId, "-").concat(rowNumber)
  }, isEmpty ? /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0") : /*#__PURE__*/React.createElement(I18n, {
    i18n: label,
    escape: escape
  })));
}
function FieldSelection(_ref3) {
  var record = _ref3.record,
    index = _ref3.index,
    property = _ref3.property,
    rowNumber = _ref3.rowNumber,
    uiSchema = _ref3.uiSchema;
  var _useContext = useContext(RecordCompareStateContext),
    master = _useContext.master,
    selections = _useContext.selections,
    mergeSelections = _useContext.mergeSelections;
  var key = "r".concat(rowNumber, "-c").concat(index);
  var handleChange = useCallback(function (e) {
    mergeSelections(_defineProperty({}, property, Object.assign({}, selections[property], _defineProperty({}, key, e.target.checked))));
  }, [selections, property, key, mergeSelections]);
  var checked = !!(selections[property] && selections[property][key]);
  var enabled = master === index || arrayHasAllEnabledFields(property, uiSchema);
  return /*#__PURE__*/React.createElement(Tooltip, {
    i18nKey: "@dm/components.record-compare.tooltips.merge-disabled-field",
    neverShow: enabled
  }, function (_ref4) {
    var ref = _ref4.ref,
      describedby = _ref4.describedby,
      events = _ref4.events;
    return /*#__PURE__*/React.createElement("span", Object.assign({
      className: styles.checkbox,
      "aria-describedby": describedby,
      ref: ref
    }, events), /*#__PURE__*/React.createElement(CheckboxInput, {
      checked: checked,
      disabled: !enabled,
      id: "array-select-".concat(property, "-").concat(record.recordId, "-").concat(rowNumber),
      label: "@dm/components.record-compare.labels.array-checkbox",
      "aria-labelledby": "merge-data-".concat(property, "-").concat(rowNumber, "-").concat(index),
      "aria-describedby": "merge-".concat(property, "-").concat(rowNumber, " ").concat(getColumnId(index)),
      labelHidden: true,
      onChange: handleChange,
      size: "large"
    }));
  });
}
function ArrayLayoutGroup(props) {
  var layout = props.layout;
  var Component = props.component;
  return /*#__PURE__*/React.createElement(React.Fragment, null, layout.map(function (item) {
    var id = item.id,
      type = item.type;
    switch (type) {
      case 'field':
        return /*#__PURE__*/React.createElement(Component, Object.assign({}, props, {
          key: "".concat(type, ".").concat(id),
          property: id
        }));
      case 'group':
        return /*#__PURE__*/React.createElement(ArrayLayoutGroup, Object.assign({}, props, {
          key: "".concat(type, ".").concat(id),
          layout: item.children
        }));
      default:
        return undefined;
    }
  }));
}
export default function ArrayRow(_ref5) {
  var parentUiSchema = _ref5.parentUiSchema,
    property = _ref5.property,
    rowNumber = _ref5.rowNumber;
  var _useContext2 = useContext(CompareContext),
    records = _useContext2.records,
    layout = _useContext2.layout;
  var _useContext3 = useContext(RecordCompareStateContext),
    isMergeEnabled = _useContext3.isMergeEnabled,
    selections = _useContext3.selections;
  var theme = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(LazyContainer, {
    placeholderI18nKey: '@dm/components.record-compare.labels.lazy-placeholder',
    placeholderHeight: '5em',
    tabbable: false
  }, function (_ref6) {
    var ref = _ref6.ref,
      className = _ref6.className;
    return /*#__PURE__*/React.createElement("div", {
      ref: ref,
      className: "".concat(className, " ").concat(styles[theme])
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Column, {
      id: "merge-".concat(property, "-").concat(rowNumber),
      className: styles['item-name']
    }, /*#__PURE__*/React.createElement(ItemName, {
      uiSchema: parentUiSchema,
      property: property,
      rowNumber: rowNumber + 1
    }))), /*#__PURE__*/React.createElement(Row, {
      className: styles['data-row']
    }, /*#__PURE__*/React.createElement(Column, {
      className: styles.overflow
    }, /*#__PURE__*/React.createElement(ArrayLayoutGroup, {
      layout: layout,
      records: records,
      component: FieldTitle
    })), records.map(function (record, index) {
      return /*#__PURE__*/React.createElement(Column, {
        key: "col-".concat(property, "-").concat(index),
        highlight: isMergeEnabled && selections[property] && selections[property]["r".concat(rowNumber, "-c").concat(index)]
      }, record.hasData && /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles['row-container'])
      }, /*#__PURE__*/React.createElement("div", {
        className: styles['row-select']
      }, isMergeEnabled && /*#__PURE__*/React.createElement(FieldSelection, {
        index: index,
        property: property,
        record: record,
        rowNumber: rowNumber,
        uiSchema: parentUiSchema
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.overflow,
        id: "merge-data-".concat(property, "-").concat(rowNumber, "-").concat(index)
      }, /*#__PURE__*/React.createElement(ArrayLayoutGroup, {
        arrayProperty: property,
        component: FieldValue,
        index: index,
        layout: layout,
        property: property,
        record: record,
        records: records,
        rowNumber: rowNumber
      }))));
    })));
  });
}